import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createSlackCommunicationsSlice } from './actions';
import { SlackCommunicationsStore } from './types';
import { ZustandStores } from '../../utils';
import { createIndexedDBStorage } from '../../utils/indexedDBAdapter';

export const useSlackCommunicationsStore = create<SlackCommunicationsStore>()(
  persist(
    (set, get, store) => ({
      ...createSlackCommunicationsSlice(set, get, store),
    }),
    {
      name: ZustandStores.SLACK_COMMUNICATIONS,
      storage: createJSONStorage(() => createIndexedDBStorage()),
    },
  ),
);
